<template>
<div ref="ytterclass" class="ytterclass">

    <div class="grammatik">

<div class="bok-container">
    <div class="bokflik" v-if="grambok === true">
    <div class="visa bok bokstart" ref="visa" v-on:click="visaGrammatik()">
          <font-awesome-icon icon="book"></font-awesome-icon> <br> <i class="arrow right istyle"></i>

    </div>


    <div class="dolj bok bokstart" ref="dolj" v-on:click="doljGrammatik()">
          <font-awesome-icon icon="book"></font-awesome-icon> <br> <i class="arrow left istyle"></i>
    </div>
    </div>

<div class="fakta" ref="fakta">

    <PresensAvSvagaVerb v-if="title === 'Presens av svaga verb'"/>
    <PresensAvStarkaVerb v-if="title === 'Presens av starka verb'"/>
    <PresensAvSein v-if="title === 'Presens av sein'"/>
    <PresensAvHaben v-if="title === 'Presens av haben'"/>

    <PerfektAvSvagaVerb v-if="title === 'Perfekt av svaga verb'"/>
    <PerfektAvStarkaVerb v-if="title === 'Perfekt av starka verb'"/>
    <PerfektMedSeinSomHjalpverb v-if="title === 'Perfekt med sein som hjälpverb'"/>

    <ModalaHjalpverb v-if="title === 'Modala hjälpverb'"/>
    <InfinitivPerfekt v-if="title === 'Infinitiv vs perfektparticip'"/>

    <ImperfektAvSvagaVerb v-if="title === 'Imperfekt av svaga verb'"/>
    <ImperfektAvStarkaVerb v-if="title === 'Imperfekt av starka verb'"/>


    <DerOrd v-if="title === 'der-ord'"/>
    <DasOrd v-if="title === 'das-ord'"/>
    <DieOrd v-if="title === 'die-ord'"/>
    <GenusOchPlural v-if="title === 'Genus och plural'"/>


    <Adjektiv v-if="title === 'Stark och svag böjning'"/>
    <AdjektivKomparation v-if="title === 'Komparation'"/>


    <PrepositionerSomStyrAckusativ v-if="title === 'Prepositioner som styr ackusativ'"/>
    <PrepositionerSomStyrDativ v-if="title === 'Prepositioner som styr dativ'"/>
    <PrepositionerSomStyrAckusativEllerDativ v-if="title === 'Prepositioner som styr ackusativ eller dativ'"/>
    <PrepositionerBlandadeOvningar v-if="title === 'Prepositioner blandade övningar'"/>
    <PrepositionerSpeciellaVerbuttryck v-if="title === 'Prepositioner i speciella verbuttryck'"/>
    <Pronominaladverb v-if="title === 'Pronominal-adverb'"/>


    <PossessivaPronomen v-if="title === 'Possessiva pronomen'"/>
    <RelativaPronomenNominativ v-if="title === 'Relativa pronomen i nominativ' || title === 'Relativa pronomen i alla kasus'"/>

    <RelativaPronomen v-if="title === 'Relativa pronomen i alla kasus'"/>

    <SehrVielViele v-if="title === 'Sehr, viel, viele'"/>

    <Klockan v-if="title === 'Klockan'"/>
    <Nar v-if="title === 'När'"/>
    <HurOfta v-if="title === 'Hur ofta'"/>


    <AlsWannWenn v-if="title === 'När\nals/wann/wenn'"/>
    <ObWenn v-if="title === 'Om - ob/wenn'"/>
    <DarforDarforAtt v-if="title === 'Därför, därför att, för att'"/>
    <Subjunktioner v-if="title === 'Subjunktioner'"/>

    <Ackusativobjekt v-if="title === 'Ackusativ-objekt'"/>
    <AckusativOchDativobjekt v-if="title === 'Ackusativ- och dativobjekt'"/>
    <VerbSomStyrDativ v-if="title === 'Verb som styr dativ'"/>
    <Genitiv v-if="title === 'Genitiv'"/>

    <Testgrammatik v-if="title === 'Testövningar'"/>


</div>
</div>

</div>

<!-- här börjar skrivarket -->
    <div class="ark-container">
  <div id="ark" class="ark">




    <h3>{{ title }}</h3>










<div class="fuskOrd doljTyska" id="fuskOrd"></div>


<div class="eraser">

<div class="eraser-button"  @click="sudda(uppgifter)"
@mousedown="touchstart()" @mouseup="touchend()"
@touchstart="touchstart()" @touchend="touchend()">
<font-awesome-icon icon="eraser" ></font-awesome-icon>
</div>




<!--div class="restart-button" @click="startaOm(uppgifter)">

<font-awesome-icon icon="eraser" ></font-awesome-icon>

<font-awesome-icon icon="exclamation-triangle" ></font-awesome-icon>

</div-->





</div>

<div id="keyboard" class="keyboardsynlighet">
<div class="inlajn keyboardletter" @click="type('ü')"> ü </div>
<div class="inlajn keyboardletter" @click="type('Ü')"> Ü </div>
<div class="inlajn keyboardletter" @click="type('ß')"> ß </div>


</div>




      <div class="uppgift" v-for="(item, index) in uppgifter" v-bind:key="index">

    <div v-if="dinRattning[index]!='rätt'">

        <div class="fraga">
              {{index +1 }}.
              <div class="fragerad" v-for="(item2, index2) in arraifieraOrd(item[0]) " v-bind:key="index2">
                 <div v-if="(item[2][index2])" class="ord fragerad pekare" :id="'ord' + index2"
                    @mousedown="visaTyska(item[2][index2])"
                    @mouseup="doljTyska()"
                    >
                 {{item2}}
                </div>
                <div v-else class="ord fragerad" :id="'ord' + index2">
                    {{item2}}
                </div>
              </div>
        </div>


        <div>
            <form autocomplete="off">
         <input class="skrivfalt" type="text" :id="'skrivfalt' + index"
           @keydown.13.prevent
           @keydown="sparaKnapptryck(index)"

           @keydown.160="umlautTryckts()"
           @keydown.186="umlautTryckts()"

           @keydown.dead="umlautTryckts()"

           @keydown.116.prevent @keydown.116="skrivDubbelEss(index)"
           @keydown.83.prevent @keydown.83="skrivDubbelEssMedCtrl(index)"

           @keydown.85.prevent @keydown.85="skrivTysktY(index)"

           @click="setFocus(index)"


           spellcheck="false"/>
       </form>
        </div>

        <div class="facitomrade">

          <div class="svar">
            <div class="svar-text" :id="'svar' + index">
              {{ item[1] }}
            </div>
          </div>

          <div class="oga" :id="'oga' + index"
          @mousedown="visaFacit(index)" @mouseup="doljFacit(index)"
          @touchstart="visaFacit(index)" @touchend="doljFacit(index)">
              <i class="fa fa-eye"></i>
          </div>

        </div>


    </div>

      </div>
<div v-if="fullrattad"><h4>Du har klarat alla uppgifter på denna övning.</h4>
    Håll inne suddgummi-ikonen uppe till vänster i 3 sekunder om du vill börja om.<br><br><br></div>

<div class="nav-rad">
    <router-link class="foregaende steg-nav" :to="{path: foregaendeLank }">
                  {{foregaende}}
    </router-link>

    <div class="pekare" id="tillRattning" @click="tillRattning()">Rättning</div>

    <router-link class="nasta steg-nav" :to="{path: nastaLank }">
                  {{nasta}}
    </router-link>

</div>



  </div>



</div>

<!-- här slutar skrivarket -->




<!-- här börjar facit....................................................................... -->
    <div class="ark-container-facit">
  <div id="facit-ark" class="ark-facit osynlig">
    <h3>{{ title }}</h3>
    <h4 class="rod">Rättning</h4>

      <div class="uppgift facit-uppgift" v-for="(item, index) in uppgifter" v-bind:key="index">

        <div class="fraga gra-text">
                          {{index +1 }}. {{ item[0] }}
        </div>

          <!-- här skrivs sen användarens svar med fyllFacit()..Detta skapar bara id:ar............................. -->
        <div>

           <div class="skrivfalt-facit smalare-border" :id="'facitfalt' + index">

           </div>

        </div>




        <div class="facitomrade">

          <div class="svar">
            <div class="facit-text" :id="'svar' + index">
              {{ item[1] }}
            </div>
          </div>



          <div :id="'kommentarsfalt'+index"> <!-- försök att loopa i loop i kommentars array-->
                <div class="kommentarer" v-for="(item2, index2) in rattningskommentarer[index]" v-bind:key="index2">
                    <br>&#9888; {{item2}}

                </div>
        </div>


          <div class="rattningsknappar">

          <div class="rodknapp knapp pekare" :id="'rodknapp' + index" @click="rodtryckt(index)">
              FEL
          </div>

          <div class="gronknapp knapp pekare" :id="'gronknapp' + index" @click="grontryckt(index)">
              RÄTT
          </div>

      </div>

        </div>

      </div>

<div class="nav-rad">
<div id="allaRätt" v-if="arAlltRatt()" class="vit-puls"> Du har alla rätt !!!</div>
<div id="tranaIgen" class="pekare" @click="tranaIgen()">Träna igen på det som blev fel</div>

</div>
  </div>
</div>

<!-- här slutar facit.................................................................................. -->





</div>
</template>

<script>



import PresensAvSvagaVerb from './grammatik/presens-av-svaga-verb.vue'
import PresensAvStarkaVerb from './grammatik/presens-av-starka-verb.vue'
import PresensAvSein from './grammatik/presens-av-sein.vue'
import PresensAvHaben from './grammatik/presens-av-haben.vue'

import PerfektAvSvagaVerb from './grammatik/perfekt-svaga-verb.vue'
import PerfektAvStarkaVerb from './grammatik/perfekt-starka-verb.vue'
import PerfektMedSeinSomHjalpverb from './grammatik/perfekt-sein-som-hjalpverb.vue'

import ModalaHjalpverb from './grammatik/modala-hjalpverb.vue'
import InfinitivPerfekt from './grammatik/infinitiv-vs-perfekt.vue'

import ImperfektAvSvagaVerb from './grammatik/imperfekt-av-svaga-verb.vue'
import ImperfektAvStarkaVerb from './grammatik/imperfekt-av-starka-verb.vue'



import DerOrd from './grammatik/der-ord.vue'
import DasOrd from './grammatik/das-ord.vue'
import DieOrd from './grammatik/die-ord.vue'
import GenusOchPlural from './grammatik/genus-och-plural.vue'

import Adjektiv from './grammatik/adjektiv-stark-svag-bojning.vue'
import AdjektivKomparation from './grammatik/adjektiv-komparation.vue'

import PrepositionerSomStyrAckusativ from './grammatik/prepositioner-som-styr-ackusativ.vue'
import PrepositionerSomStyrDativ from './grammatik/prepositioner-som-styr-dativ.vue'
import PrepositionerSomStyrAckusativEllerDativ from './grammatik/prepositioner-som-styr-ackusativ-eller-dativ.vue'
import PrepositionerBlandadeOvningar from './grammatik/prepositioner-blandade-ovningar.vue'
import PrepositionerSpeciellaVerbuttryck from './grammatik/prepositioner-speciella-verbuttryck.vue'
import Pronominaladverb from './grammatik/pronominaladverb.vue'


import PossessivaPronomen from './grammatik/possessiva-pronomen.vue'
import RelativaPronomen from './grammatik/relativa-pronomen.vue'
import RelativaPronomenNominativ from './grammatik/relativa-pronomen-nominativ.vue'

import SehrVielViele from './grammatik/sehr-viel-viele.vue'

import Klockan from './grammatik/klockan.vue'
import Nar from './grammatik/nar.vue'
import HurOfta from './grammatik/hur-ofta.vue'

import AlsWannWenn from './grammatik/als-wann-wenn.vue'
import ObWenn from './grammatik/ob-wenn.vue'
import DarforDarforAtt from './grammatik/darfor-darfor-att-for-att.vue'
import Subjunktioner from './grammatik/subjunktioner.vue'

import Ackusativobjekt from './grammatik/ackusativobjekt.vue'
import AckusativOchDativobjekt from './grammatik/ackusativ-och-dativobjekt.vue'
import VerbSomStyrDativ from './grammatik/verb-som-styr-dativ.vue'
import Genitiv from './grammatik/genitiv.vue'


export default {
  name: 'Ovningsblad',
  title () {
    return `${this.title} | Tysk Grammatik`
  },
  components: {
    PresensAvSvagaVerb,
    Adjektiv,
    PresensAvSein,
    Ackusativobjekt,
    AckusativOchDativobjekt,
    Genitiv,
    AdjektivKomparation,
    PerfektAvSvagaVerb,
    PerfektAvStarkaVerb,
    PerfektMedSeinSomHjalpverb,
    PresensAvHaben,
    PresensAvStarkaVerb,
    DerOrd,
    DasOrd,
    DieOrd,
    GenusOchPlural,
    AlsWannWenn,
    ImperfektAvSvagaVerb,
    ImperfektAvStarkaVerb,
    ObWenn,
    Subjunktioner,
    VerbSomStyrDativ,
    PrepositionerSomStyrAckusativ,
    PrepositionerSomStyrDativ,
    PrepositionerSomStyrAckusativEllerDativ,
    PrepositionerBlandadeOvningar,
    PossessivaPronomen,
    RelativaPronomen,
    RelativaPronomenNominativ,
    PrepositionerSpeciellaVerbuttryck,
    Pronominaladverb,
    ModalaHjalpverb,
    DarforDarforAtt,
    SehrVielViele,
    InfinitivPerfekt,
    Klockan,
    Nar,
    HurOfta
},
  props: {
    title: String,
    uppgifter: Array,
    grammatik: String,
    avsnitt: String,
    grambok: Boolean,
    foregaende:String,
    nasta:String,
    foregaendeLank:String,
    nastaLank:String
    /*fullrattad: Boolean*/
},


/*metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: `${this.title}`
            }
        ]
    }
},*/



data() {
    var that=this;
    //var umlaut = false;

        return {
            dinRattning: window.document.done[that.avsnitt]['dinRattning'],
            hover: false,
            fullrattad: Boolean,


            timer:Function,
            touchduration: 3000,
            rattningskommentarer:[],
            umlaut: false, //kolla om detta
            cursorX: Number,
            cursorY:Number


        }
},

methods: {
    touchstart() {
    this.timer = setTimeout(this.onlongtouch, this.touchduration);
    },
    touchend() {

    //stops short touches from firing the event
    if (this.timer)
        clearTimeout(this.timer); // clearTimeout, not cleartimeout..
    },

    onlongtouch() {
        this.startaOm(this.uppgifter);

    },

    skrivDubbelEssMedCtrl: function(index) {
        if(event.ctrlKey || event.altKey) {
          this.skrivDubbelEss(index);
        } else {
          var falt = document.getElementById('skrivfalt' + index);
          var aktPos = falt.selectionStart;
          if(event.shiftKey) {
              falt.value = falt.value.substr(0, aktPos) + 'S' + falt.value.substr(aktPos, falt.value.lenght);
          } else {
              falt.value = falt.value.substr(0, aktPos) + 's' + falt.value.substr(aktPos, falt.value.lenght);
          }

          falt.selectionStart = aktPos + 1;
          falt.selectionEnd = aktPos + 1;
        }

    },



    umlautTryckts: function(){
      this.umlaut = true;
    },

    skrivTysktY: function(index) {
      //om kontroll nedtryckt
        if(event.ctrlKey || event.altKey) {
          var falt = document.getElementById('skrivfalt' + index);
          var aktPos = falt.selectionStart;
          if(event.shiftKey) {
              falt.value = falt.value.substr(0, aktPos) + 'Ü' + falt.value.substr(aktPos, falt.value.lenght);
          } else {
              falt.value = falt.value.substr(0, aktPos) + 'ü' + falt.value.substr(aktPos, falt.value.lenght);
          }

          falt.selectionStart = aktPos + 1;
          falt.selectionEnd = aktPos + 1;
        } else {

          // om chromebook
          /*if (window.navigator.userAgent.indexOf("CrOS") != -1) {
               // inte säker om detta skall stå här
          }*/


          // om ej kontroll nedtryckt skall det ju funka som vanligt men måste kolla om prickar tryckts
          if (window.navigator.platform.indexOf("Linux")!=-1 && this.umlaut && window.navigator.userAgent.indexOf("CrOS") == -1) {
            this.umlaut = false;
            return; // skall returna om linux ty där funkar omlaut ändå

          } // obs om den är chromebook tycker den att den är linux också därför måste säkerställas att linux men EJ chromebook



          falt = document.getElementById('skrivfalt' + index);
          aktPos = falt.selectionStart;
          if(event.shiftKey) {

            if(this.umlaut) {falt.value = falt.value.substr(0, aktPos) + 'Ü' + falt.value.substr(aktPos, falt.value.lenght); this.umlaut= false;return;}
              falt.value = falt.value.substr(0, aktPos) + 'U' + falt.value.substr(aktPos, falt.value.lenght);
          } else {

            if(this.umlaut) {falt.value = falt.value.substr(0, aktPos) + 'ü' + falt.value.substr(aktPos, falt.value.lenght); this.umlaut= false;return;}
              falt.value = falt.value.substr(0, aktPos) + 'u' + falt.value.substr(aktPos, falt.value.lenght);
          }

          falt.selectionStart = aktPos + 1;
          falt.selectionEnd = aktPos + 1;
        }

    },



    skrivDubbelEss: function(index) {
        var falt = document.getElementById('skrivfalt' + index);
        var aktPos = falt.selectionStart;
        falt.value = falt.value.substr(0, aktPos) + 'ß' + falt.value.substr(aktPos, falt.value.lenght);
        falt.selectionStart = aktPos + 1;
        falt.selectionEnd = aktPos + 1;
    },
    visaFacit: function(index) {

        document.getElementById('svar' + index).classList.add("visa-svar");
        document.getElementById('oga' + index).classList.add("visa-oga");
    },
    doljFacit: function(index) {

        document.getElementById('svar' + index).classList.remove("visa-svar");
        document.getElementById('oga' + index).classList.remove("visa-oga");
    },
    fyllOvningar: function(uppgifter) {

        var that = this;
        var langd = uppgifter.length;
        for (var i=0; i< langd; i++) {
            if (window.document.done[that.avsnitt]['dinRattning'][i] != "rätt") {
                var falt = document.getElementById('skrivfalt' + i);
                falt.value = window.document.done[that.avsnitt]['dittSvar'][i] || "";
            }
        }
    },
    fyllFacit: function(uppgifter) {
        var that = this;
        uppgifter.forEach(function(element, index) {
            var facitfalt = document.getElementById('facitfalt' + index); //är nog vad användare skrev

            var anvandarensSvar = window.document.done[that.avsnitt]['dittSvar'][index]; // här måste joxas för att kunna rödmarkera under ord



            //kanske i bästa fall räcker med att lägga en till funktion här som bearbetar anvandarensSvar. Påbörjat 250308
            var svarcontainer =  document.createElement("div");

            //svarcontainer.style="display: inline"

            var svarskedja;
            if(anvandarensSvar != null) {
              svarskedja = anvandarensSvar.split(" ");
            }

            var i=0;
            if(svarskedja) {
              for(i; i<svarskedja.length; i++){
                  var ordelement = document.createElement("div");
                  ordelement.innerHTML=svarskedja[i];
                  ordelement.style="display: inline";

                  //försök kolla om aktuellt ord att ev understryka ej finns i facit

                  //if(!element[1].includes(svarskedja[i])) {
                  if(!that.finnsOrdIKedjan(svarskedja[i], element[1])){
                    ordelement.style="text-decoration: underline; text-decoration-color: red; text-decoration-style: wavy;  display: inline";
                  }

                  var tomrum =  document.createElement("div");
                  tomrum.style="display: inline";
                  tomrum.innerHTML=" ";

                  svarcontainer.appendChild(ordelement);
                  svarcontainer.appendChild(tomrum);
              }
            }



            //console.log(svarcontainer);
            facitfalt.innerHTML="";
            facitfalt.append(svarcontainer);

            // ovanstående 250308

            //facitfalt.innerHTML = anvandarensSvar  || "";  //denna var i originalet

        })

    },
    finnsOrdIKedjan: function(ord, kedja){


      var facitfält = kedja.split(" ");
      var resultat = false;
      facitfält.forEach(function(item) {
        //console.log(item);
        if(item.replace(/[.,!?]/g, '') == ord.replace(/[.,!?]/g, '')) {
          resultat = true;

        }

      });
      return resultat;

    },
    sparaKnapptryck: function(index) {

      //joxande för att få virt keyboard att funka

      var falt = document.getElementById('skrivfalt' + index);
      this.cursorX = falt.selectionStart;
      this.cursorY=index;
      // ------------------------------



      //nedan bör läggas som särskild funktion som kan åkallas såväl från riktigt knapptryck som från virtualkeyboard-tryck
        var that = this;
        setTimeout(function(){
            var falt = document.getElementById('skrivfalt' + index);
            window.document.done[that.avsnitt]['dittSvar'][index] = falt.value;
        },10); //ska va 10

        //window.localStorage.done[this.avsnitt][index] = falt.value;

    },
    sudda: function(uppgifter) {

        var that = this;
        var langd = uppgifter.length;
        for (var i=0; i< langd; i++) {
            if (window.document.done[that.avsnitt]['dinRattning'][i] != "rätt") {
                var falt = document.getElementById('skrivfalt' + i);
                window.document.done[that.avsnitt]['dittSvar'][i] = "";
                falt.value = "";
            }
        }
    },

        /*var that = this;
        uppgifter.forEach(function(element, index) {
            var falt = document.getElementById('skrivfalt' + index);
            window.document.done[that.avsnitt]['dittSvar'][index] = "";
            falt.value = "";
        });*/
    visaGrammatik: function() {
        this.$refs.fakta.classList.add("bredd");
        this.$refs.visa.style="display: none;"
        this.$refs.dolj.style="display: block;"
        this.$refs.visa.classList.remove("bokstart");
        this.$refs.dolj.classList.remove("bokstart");
    },
    doljGrammatik: function() {
        this.$refs.fakta.classList.remove("bredd");
        this.$refs.dolj.style="display: none;"
        this.$refs.visa.style="display: block;"
    },
    arraifieraOrd: function(str) {
        var res = str.split(" ");
        return res;
    },


    visaTyska: function(ord) {
        if (ord) {
        var e=window.event;
        var posX = e.clientX;
        var posY = e.clientY;
        var element = document.getElementById('fuskOrd');
        element.classList.remove("doljTyska");
        element.classList.add("visaTyska");
        element.style.top=(posY -50 + "px");
        element.style.left=(posX + "px");
        element.innerHTML = ord;
        setTimeout(function() {
            element.style.opacity="1";
        },1);

        }
    },
    doljTyska: function() {
        var element = document.getElementById('fuskOrd');
        element.classList.remove("visaTyska");
        element.classList.add("doljTyska");
        element.innerHTML = "";
        element.style.opacity="0";
    },
    sattKnappfarg: function(index, typ) {
        var rodknapp = document.getElementById('rodknapp' + index);
        var gronknapp = document.getElementById('gronknapp' + index);

        rodknapp.classList.remove("svagare");
        rodknapp.classList.remove("rod-puls");
        gronknapp.classList.remove("svagare");
        gronknapp.classList.remove("gron-puls");

        if(typ==="tom") {
            rodknapp.classList.add("rod-puls");
            gronknapp.classList.add("gron-puls");
        }
        if(typ==="gron") {
            rodknapp.classList.add("svagare");
        }
        if(typ==="rod") {
            gronknapp.classList.add("svagare");
        }
    },

    fargaKnappar: function(uppgifter) {
        this.rattningskommentarer = [];
        var that=this;
        var rattning = window.document.done[that.avsnitt];
        uppgifter.forEach(function(element, index) {

            that.sattKnappfarg(index, "tom");


            //om användaren tycker rätt
            if(rattning['dinRattning'][index] !="rätt") {



            /* helt rätt är alltid rätt*/
            if (rattning['dittSvar'][index] === that.uppgifter[index][1]){
                    window.document.done[that.avsnitt]['dinRattning'][index]="rätt";
                    that.rattningskommentarer.push([]); //om helt rätt behövs inga kommernatarer utan tom array


                    // om fältet helt tomt gör grått

                } else if ( (!rattning['dittSvar'][index])  ){
                    window.document.done[that.avsnitt]['dinRattning'][index]="";
                    that.rattningskommentarer.push([]);

                    // om halvrätt - gör rött men skriv också kommentarer alt skriv inga kommentarer om helfel
                } else {

                    window.document.done[that.avsnitt]['dinRattning'][index]="fel";

                    //här skall vi kalla på rättningsfunktionerna
                    var rattningsfeedback = that.svarskollen(that.uppgifter[index][1], rattning['dittSvar'][index])

                    that.rattningskommentarer.push(rattningsfeedback); //om helt rätt behövs inga kommernatarer utan tom array


                }

            } else {
                that.rattningskommentarer.push([]);
            }

            //här korrigeras knappfärgerna
            if(rattning['dinRattning'][index]==="fel") {
                that.sattKnappfarg(index, "rod");
            }
            if(rattning['dinRattning'][index]==="rätt") {
                that.sattKnappfarg(index, "gron");
            }
            if(!(rattning['dinRattning'][index])) {
                that.sattKnappfarg(index, "tom");
            }

        })
    },
    grontryckt: function(index) {
        var that=this;
        var rattning = window.document.done[that.avsnitt]['dinRattning'][index];
        if (rattning === null || rattning === "" || rattning === "fel" ) {
            window.document.done[that.avsnitt]['dinRattning'][index] = "rätt"
            that.sattKnappfarg(index, "gron");

        } else {
            window.document.done[that.avsnitt]['dinRattning'][index] = "";
            that.sattKnappfarg(index, "tom");
        }
    },
    rodtryckt: function(index) {
        var that=this;
        var rattning = window.document.done[that.avsnitt]['dinRattning'][index];
        if (rattning === null || rattning === "" || rattning === "rätt") {
            window.document.done[that.avsnitt]['dinRattning'][index] = "fel";
            that.sattKnappfarg(index, "rod");
        } else {
            window.document.done[that.avsnitt]['dinRattning'][index] = "";
            that.sattKnappfarg(index, "tom");
        }
    },
    tillRattning: function() {
        var that = this
        document.getElementById('ark').classList.add("osynlig");
        document.getElementById('facit-ark').classList.remove("osynlig");
        window.scrollTo(0,0);
        this.fyllFacit(that.uppgifter);
        this.fargaKnappar(that.uppgifter);

    },
    tranaIgen: function() {
        this.allaRatt();
        document.getElementById('facit-ark').classList.add("osynlig");
        document.getElementById('ark').classList.remove("osynlig");
        this.$forceUpdate();
    },
    allaRatt: function() {
        this.fullrattad = false;
        var g=0;
        window.document.done[this.avsnitt]['dinRattning'].forEach((item) => {
            if (item==="rätt") {
                g++;
            }
        });

        if (g==this.uppgifter.length) {
            this.fullrattad = true;

        }
    },
    arAlltRatt: function(){ //denna är i princip som förra men används för att skriv alla rätt. förra används efteråt för att ev ej visa facit
      var status = false; // den förra kan tas bort. Och denna kan programmeras så att hittat fel eller "" ger false och inte
      var g=0;            // räkna antalet rätt ty window.document.done kan ha fler eller färre items än this.uppgifter
      window.document.done[this.avsnitt]['dinRattning'].forEach((item) => { // pga tidigare sparning i webbläsarminnet
          if (item==="rätt") {
              g++;
          }
      });

      if (g==this.uppgifter.length) {
          status = true;

      }
      return status;

    },
    startaOm: function(uppgifter) {
        var that = this;
        var langd = uppgifter.length;
        for (var i=0; i< langd; i++) {
            window.document.done[that.avsnitt]['dinRattning'][i] = "";
            window.document.done[that.avsnitt]['dittSvar'][i] = "";
            this.fullrattad = false;
        }
            document.getElementById('ark').classList.add("osynlig");
            document.getElementById('ark').classList.remove("osynlig");
            this.$forceUpdate();
    },

    //för att få rättningskommentarer
    svarskollen: function(facit, svar){
      var svarsarray = [];

      //om det var HELT rätt
      if(facit == svar) {
        svarsarray.push("rätt");

        return svarsarray;
      }

      // var bara skrifläge fel returna det
      if (svar.toLowerCase() == facit.toLowerCase()) {
        svarsarray.push("stor/liten bokstav");
        return svarsarray;
      }

      // svar bara skiljetecken fel - returna det
      if (this.skippaSkiljetecken(svar) == this.skippaSkiljetecken(facit)) {
        svarsarray.push("skiljetecken");
        return svarsarray;
      }


      // var BÅDE skiljetecken OCH skriftläge fel, men bara det - returna det
      if (this.skippaSkiljetecken(svar.toLowerCase()) == this.skippaSkiljetecken(facit.toLowerCase())) {
        svarsarray.push("skiljetecken");
        svarsarray.push("stor/liten bokstav");
        return svarsarray;
      }

      //om ordföljden är fel (med rätt eller fel skriftläge och skiljetecen)
      if (this.kollaOrdföljd(facit, svar)) {
        svarsarray.push("ordföljd");
        return svarsarray;
      }


      //om artiklar är fel (med rätt eller fel skriftläge och skiljetecen)
      if (this.kollaArtiklar(facit, svar)) {
        svarsarray.push("artiklar");
        return svarsarray;
      }

        // inget enkelt fixbart fel hittades utan "helfel" och ingen kommentar skickas med

          return svarsarray;
    },
    skippaSkiljetecken: function(input) {
      var resultat = input.replace(/,/g, '');
      resultat = resultat.replace(/\./g, '');
      resultat = resultat.replace(/!/g, '');
      resultat = resultat.replace(/\?/g, '');
      return resultat
    },
    kollaOrdföljd: function(facit, svar) {
      var trimmatFacit = this.skippaSkiljetecken(facit.toLowerCase());
      var trimmatSvar = this.skippaSkiljetecken(svar.toLowerCase());
      var facitFält = trimmatFacit.split(" ");
      var svarFält = trimmatSvar.split(" ");

      var resultat = true;
      svarFält.forEach((item) => {
        if(!facitFält.includes(item)) {
          resultat = false;
        }
      });

      if(facitFält.length != svarFält.length){
        resultat = false;
      }
      return resultat;
   },
   kollaArtiklar: function(facit, svar) {

      var trimmatFacit = this.skippaSkiljetecken(facit.toLowerCase());
      var trimmatSvar = this.skippaSkiljetecken(svar.toLowerCase());
      var facitFält = trimmatFacit.split(" ");
      var svarFält = trimmatSvar.split(" ");



      if(facitFält.length !=svarFält.length) {

        return false;  //fel antal ord från början ingen idé kolla
      }

      var artikelfält = ["der", "die", "das", "den", "dem", "des", "einen", "ein", "eine", "einer"];
    // ta bort alla artiklar
      for (var i = facitFält.length; i>=0; i--){
        if (artikelfält.includes(facitFält[i])) {
          facitFält.splice(i,1);
        }
        if (artikelfält.includes(svarFält[i])) {
          svarFält.splice(i,1);
        }
      }


      if(facitFält.length !=svarFält.length) {
        return false;  // nåt var artikel och helt annat ord i annan mening - ingen ide
      }


      var resultat = true;

      for (i = 0; i<facitFält.length; i++){
        if(facitFält[i]!=svarFält[i]) {
          resultat = false;
        }
      }
      return resultat;
   },

   //metod för att skriva tecken från virtuellt keyboard
   type(character) {

     var falt = document.getElementById('skrivfalt' + this.cursorY);
     if(falt==null) return;
     var aktPos = falt.selectionStart;
     falt.value = falt.value.substr(0, aktPos) + character + falt.value.substr(aktPos, falt.value.lenght);
     falt.selectionStart = aktPos + 1;
     falt.selectionEnd = aktPos + 1;


     falt.focus();


     var that = this;
     setTimeout(function(){
         window.document.done[that.avsnitt]['dittSvar'][that.cursorY] = falt.value;
     },10); //ska va 10
   },

   setFocus(index){
     this.cursorY = index;
     var falt = document.getElementById('skrivfalt' + index);
     this.cursorX = falt.selectionStart;
   }





},
mounted() {
        this.allaRatt();
        this.fyllOvningar(this.uppgifter);

        window.scrollTo(0, 0);
        /*this.fargaKnappar(this.uppgifter);/*lägg denna vid tillRattning()*/
        this.$refs.fakta.firstElementChild.firstElementChild.style.display="none";

    },
updated() {

    this.fyllOvningar(this.uppgifter);
        window.scrollTo(0, 0);
        this.$refs.ytterclass.style.display="none";
        var that = this;
        setTimeout(function() {
            that.$refs.ytterclass.style.display="block";
        }, 30);

    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/*fram och tillbaka tekniker för inskjutet grammatikblad*/
.dolj {
    display: none;
}


@keyframes bokblink {
  0% {color: black}
  45% {color: black}
  50% {color: grey}
  55% {color: black}
  100% {color: black}
}



.bok-container {

    /*position: sticky;*/
    top: 0;
    float: left;
    position: relative;
    z-index:10;
}

.bok {
    position: absolute;

    padding-left: 0.5em;

    top: 2px;
    z-index:15;

    background: rgba(255,255,255,0.7);
    border: solid 1px;
    border-left: none;
    padding-top:4px;
    padding-bottom:4px;
    padding-right: 3px;

    border-radius: 0 3px 3px 0;

    color: black;



}

.bokflik {

}

.visa {

}
.dolj {
    /*z-index:-1;*/
    /*top: 5em;*/
}


.bok:hover {
    color: #2c3e50;
    transition: 0.5s;
}

/*innan man nånsin tryck på knappen finns denna sen tas den bort*/
.bokstart {
    -webkit-animation: mjukframkomst 2s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjukframkomst 2s;
    /*animation-delay: 2s;*/

    animation-name: bokblink;
    animation-duration: 10s;
    animation-iteration-count: infinite;
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukframkomst {
  0% {
      opacity: 0;
  }
  50% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

/* Standard syntax */
@keyframes mjukframkomst {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }

}



.arrow {
    margin-top:0.5em;
    border-color: #2c3e50;
}
/*slut med grammatikbladtekniker*/



.ark-container {
    /*vertical-align: top;*/
    display: inline;
    position: relative;
    z-index:1;
}



.ark-container-facit {
    /*vertical-align: top;*/
    display: inline;
    position: relative;
    z-index:2;
}



.ark {
    position:relative;/*Ta bort om det fuckar sig!!!*/
    /*vertical-align: top;*/

    /*width: 800px;*/
    width: calc(100vw - 463px);
    background-color: white;
    /*background-image: linear-gradient(to bottom right, white, #ffffe0);*/
    /*margin: auto;*/
    padding: 0em 0 1em 0;


    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    color: black;
    margin-bottom: 1em;
    display: inline-block;
    z-index:1;
}


.ark-facit {
    position:relative;/*Ta bort om det fuckar sig!!!*/
    width: calc(100vw - 463px);
    background-color: #fee;
    /*background-color: #ebe7eb;*/
    padding: 0em 0 1em 0;


    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    color: black;
    margin-bottom: 1em;
    display: inline-block;
    z-index:2;

    /*display: block;*/
    -webkit-animation: mymove 1s; /* Safari 4.0 - 8.0 */
    animation: mymove 1s;



}


.osynlig {
    display: none;
}

@media (max-width: 1024px/*480px*/) {
    .ark {
        width: 100%;
    }

    .ark-facit {
        width: 100%;
    }

    .ytterclass {
        display: inline-block;
    }

    .keyboardsynlighet {

      display: none !important;

      background-color:red;
    }
}


/* Safari 4.0 - 8.0 */
@-webkit-keyframes mymove {
  from {
      margin-top: 800px;
  }
  to {
      margin-top:0px;
  }
}

/* Standard syntax */
@keyframes mymove {
    from {
        margin-top: 800px;
    }
    to {
        margin-top:0px;
    }
}



/* Safari 4.0 - 8.0 */
@-webkit-keyframes mymove2 {
  from {
      top: 0px;
  }
  to {
      top:-200px;
  }
}

/* Standard syntax */
@keyframes mymove2 {
    from {
        top: 0;
    }
    to {
        top:-200px;
    }
}







.uppgift {
    margin: 2em 1em 1em 1em;
    text-align: left;
}

.skrivfalt {
    margin-top: 0.5em;
    width: 100%;
    height: 2em;
    border-color: #b3b8bb;
    border-style: none none solid none;
    font-family: 'Kalam', serif;
    font-size: 1.5em;
    /*color: #008;*/
    background-color: rgba(255, 255, 255, 0);
}

@media (max-width: 1024px) {
    .skrivfalt {
        min-height: 1em;
        height: 100%;
    }
}

.skrivfalt-facit {
    min-height: 1em;
    height: 100%;
    margin-top: 0.5em;
    width: 100%;

    border-color: #b3b8bb;
    border-style: none none solid none;
    font-family: 'Kalam', serif;
    font-size: 1.5em;
    /*color: #008;*/
    background-color: rgba(255, 255, 255, 0);
}








input:focus {
    outline: none;
}

.fraga {
    font-family: "Times New Roman", Times, serif;
    font-size: 1.3em;

}

.svar {
    width:95%;
    display: inline-block;
}
.svar-text {
    visibility:hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
    /*display: none*/
    color: #00A;
}

.facit-text {
    color: #00A;
}

.smalare-border {
    border-width: 2px;
}

.visa-svar {
    visibility: visible;
    opacity: 1;
}

.visa-oga {
    color: black !important;
}

.facitomrade {

    width: 100%;

}
.oga {
    color: #b3b8bb;
    width:5%;
    display:inline-block;
    text-align: right;
    font-size: 1.3em;
}
h3 {
    /*padding-top: 0.5em;*/
    font-family: serif;
    /*font-size: 1.5em;*/
    font-size: 2em;

}

@media (max-width:400px) {
    h3 {
        font-size:1.5em;
    }
}
.eraser {
    text-align: left;
    padding-left: 1em;
    color: #b3b8bb;
    display: block;
    font-size: 150%;
    margin-bottom: -20px;
}

.eraser-button {

    display: inline;
}

.restart-button {
    display: inline;
    float:right;
    padding-right: 10px;
}

.eraser-button:hover {
    color: red;
}

.restart-button:hover {
    color: red;
}


.ytterclass {

    display: block;
    -webkit-animation: mymove 1s; /* Safari 4.0 - 8.0 */
    animation: mymove 1s;
    /*position: relative;
    z-index:1;*/
}

.nav-rad {
    width: 100%;
    position: relative;
    padding-top: 1em;
    padding-bottom: 2em;
}
.foregaende {
    margin-left: 1em;
    position: absolute;
    left: 0;

}
.nasta {
    margin-right: 1em;
    position: absolute;
    right: 0;
}

.steg-nav {
    text-decoration: none;
    color: grey;
}

.steg-nav:hover{
    text-decoration: underline;
}

@media (max-width:470px) {
    .steg-nav {
        display: none;
    }
}

.fragerad {
    display: inline;
}

.doljTyska{
   display: none;
}
.visaTyska {
    /*opacity: 1;*/
}

#fuskOrd {
    opacity:0;
    position: fixed;
    padding:5px;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    background-color: #eef;
    transition: opacity 0.75s;
}

.pekare {
    cursor: pointer;
}


.gra-text {
    /*margin-top: 1em;*/
    color: grey;
}

.rodknapp {
    background-color: #ff9999;
    color: #ff3333;
    margin-right: 20px;
}
.rodknapp:hover {
    border-color: black;
}

.gronknapp:hover {
    border-color: black;
}


.gronknapp {
    background-color: #99ff99;
    color: #11dd11;
}
.rattningsknappar {
    float: right;
}

.knapp {
    text-align: center;
    padding-top: 5px;
    border-radius: 3px;
    border: solid 1px;
    display: inline-block;
    width: 60px;
    height: 22px;
}

.svagare {
    filter: grayscale(100%);
}


.rod-puls {
/*    -webkit-animation: pulsera1 1s ease-out;
    -webkit-animation-iteration-count: infinite;*/
    filter: grayscale(100%);
}
@-webkit-keyframes pulsera1 {
    0% {
        filter: grayscale(100%);
    }
    50% {
        filter: grayscale(0%);
    }
    100% {
        filter: grayscale(100%);
    }
}

.gron-puls {
/*    -webkit-animation: pulsera2 1s ease-out;
    -webkit-animation-iteration-count: infinite;*/
    filter: grayscale(100%);
}
@-webkit-keyframes pulsera2 {
    0% {
        filter: grayscale(0%);
    }
    50% {
        filter: grayscale(100%);
    }
    100% {
        filter: grayscale(0%);
    }
}


.vit-puls {
  animation-name: pulsera3;
    animation-duration: 4s;
    animation-iteration-count: infinite;
}
@-webkit-keyframes pulsera3 {
    0% {
        filter: opacity(100%);
    }
    25% {
        filter: opacity(100%);
    }
    80% {
        filter: opacity(100%);
    }
    90% {
        filter: opacity(0%);
    }
    100% {
        filter: opacity(100%);
    }
}


#tillRattning {
    display: inline-block;
    border: solid 1px;
    /*border-radius: 3px;*/
    padding:6px;
    background-color: #fcc;
    /*background-color: #ebe7eb;*/
    /*font-family: 'Rochester', cursive;*/
    font-family: 'Marck Script', cursive;
    font-size: 2em;
    -webkit-box-shadow: 0 10px 6px -6px #777;
       -moz-box-shadow: 0 10px 6px -6px #777;
            box-shadow: 0 10px 6px -6px #777;
}

#tillRattning:hover {
    background-color: #fbb;

}

#tranaIgen {
    display: inline-block;
    border: solid 1px;
    padding:3px;
    background-color: #fff;
    font-family: 'Marck Script', cursive;
    font-size: 2em;
    -webkit-box-shadow: 0 10px 6px -6px #777;
       -moz-box-shadow: 0 10px 6px -6px #777;
            box-shadow: 0 10px 6px -6px #777;

}

#tranaIgen:hover {
    background-color: #eee;
}

#allaRätt {
  display: block;
  color: green;
  padding:3px;

  font-family: 'Marck Script', cursive;
  font-size: 2em;


}
.facit-uppgift {
    padding-bottom: 35px;
    border: solid 1px;
    padding-left: 5px;
    padding-right: 5px;
}

.kommentarer {
    color:#ff3333;
}

.underkrull {
  text-decoration: underline;
  text-decoration-color: red;
  text-decoration-style: wavy;
}


.keyboardsynlighet {
  display:inline;
}


#keyboard{

  color: #b3b8bb;
  position: sticky;
  top: 70px;
  background-color:white;
  padding: 5px;

  border: 2px solid #b3b8bb;
  width: 50px;


  left: calc(100vw - 300px);

}

.keyboardletter:hover {
  color: black;
  öööcursor: context-menu;
  cursor: default;
}

</style>
